export default __webpack_public_path__ + "static/media/pantry1-afterC-1920w.ac9e992b.png";